declare namespace $ {

	export class $shm_hitalama_map_widget_float_settings_customdom extends $shm_hitalama_map_widget_float_settings {
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=customdom.view.tree.d.ts.map